import styled from 'styled-components';

type PortfolioTableProps = {
  isMobileDevice: boolean;
};

export const PortfolioTable = styled.div<PortfolioTableProps>`
  overflow: auto;

  ${(props) =>
    props.isMobileDevice
      ? `height: calc(100vh - 137px);
         max-height: calc(100vh - 137px);`
      : `border-radius: 8px;
          min-height:450px`}
`;
